import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "hiddenFields"]

  remove(event) {
    event.preventDefault()
    const imageId = event.currentTarget.dataset.imageId
    const flagName = event.currentTarget.dataset.flagName
    const wrapper = event.currentTarget.closest('[data-image-wrapper]')
    
    if (imageId) {
      // Add to hidden fields to delete on server (multi-attachment)
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "delete_image_ids[]"
      if (event.currentTarget.dataset.certId) {
        input.name = "delete_certification_ids[]"
      }
      input.value = imageId
      this.hiddenFieldsTarget.appendChild(input)
    } else if (flagName) {
      // Set a simple flag for single attachment deletion
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = flagName
      input.value = "true"
      this.hiddenFieldsTarget.appendChild(input)
    }

    // Hide visually
    wrapper.classList.add("hidden")
  }
}
